import get from 'lodash.get';

import webinarBackup from '../images/webinar-backup.jpg';

export const sortByPublishDate = (a, b) => {
  if (a.publishDate < b.publishDate) {
    return 1;
  } else if (a.publishDate > b.publishDate) {
    return -1;
  }
  return 0;
};

export const createFullPostList = (posts = [], walledContent = [], webinars = []) => {
  const mappedPosts = posts.map((p) => {
    return {
      title: p.title,
      description: p.articleDescription,
      publishDate: p.publishDate,
      heroImage: get(p, 'heroImage.file.url'),
      type: flattenType(p),
      theme: flattenThemes(p),
      slug: p.slug,
      listingDescription: get(p, 'listingDescription.listingDescription'),
    };
  });

  const mappedWalled = walledContent.map((p) => {
    return {
      title: p.title,
      description: p.description,
      publishDate: p.publishDate,
      heroImage: get(p, 'heroImage.file.url'),
      type: flattenType(p),
      theme: flattenThemes(p),
      slug: p.slug,
      listingDescription: get(p, 'listingDescription.listingDescription'),
    };
  });

  const mappedWebinar = webinars
    .filter((w) => !w.inviteOnly) // GraphQL ne query is not filtering these out
    .map((p) => {
      return {
        title: p.title,
        description: get(p, 'description.description'),
        publishDate: p.publishDate,
        heroImage: get(p, 'heroImage.file.url') || webinarBackup,
        type: 'Video',
        theme: flattenThemes(p),
        slug: p.slug,
        listingDescription: get(p, 'listingDescription.listingDescription'),
      };
    });

  return [...mappedPosts, ...mappedWalled, ...mappedWebinar].sort((a, b) => {
    if (a.publishDate > b.publishDate) {
      return 1;
    } else if (a.publishDate < b.publishDate) {
      return -1;
    }
    return 0;
  });
};

export const getUrl = (item) => {
  let slug = item.slug;
  let url;
  switch (item.__typename) {
    case 'ContentfulBlogPost': {
      url = `/blog/${slug}`;
      break;
    }
    case 'ContentfulResourceCenterPost': {
      url = `/resources/${slug}`;
      break;
    }
    default: {
      url = '/blog/';
      break;
    }
  }
  return url;
};

const flattenThemes = (post) => {
  if (!post.theme) {
    return [];
  }
  let themes = [];
  post.theme.forEach((t) => themes.push(t.themeName));
  return themes;
};

const flattenType = (post) => {
  if (!post.type) return;
  return post.type.typeName;
};
